<label
  class="chk-container"
  [class.chk-container--bare]="!label && !richLabel"
  [class.chk-container--center]="centerCheckmark"
  [class.chk-container--muted]="muted"
  [class.chk-container--sm]="size === 'sm'"
  [class.chk-container--presentational]="presentational"
  [ngClass]="labelClass"
  [attr.for]="inputId"
  [attr.data-testid]="testId"
  (click)="onClick($event)"
>
  <ng-content select="[leading-icon]"></ng-content>
  <ng-container *ngIf="label">{{ label | translate }}</ng-container>
  <!-- Rich label content (markup, images) projected by the call site. -->
  <ng-content></ng-content>
  <span *ngIf="tooltip" class="chk-tooltip" [attr.title]="tooltip | translate"
    >?</span
  >
  <input
    type="checkbox"
    [id]="inputId"
    [attr.value]="nativeValue"
    [attr.name]="name"
    [checked]="value"
    [indeterminate]="indeterminate"
    [disabled]="disabled"
    [attr.tabindex]="presentational ? -1 : null"
    [attr.aria-hidden]="presentational ? 'true' : null"
    (click)="onClick($event)"
    (change)="onNativeChange($event)"
    (blur)="onTouched()"
  />
  <span class="checkmark"
    ><ng-content select="[checkmark-content]"></ng-content
  ></span>
</label>

<app-explanation *ngIf="helpText" [text]="helpText"></app-explanation>

<div *ngIf="isInvalid && errorText" class="invalid-feedback d-block">
  <span>{{ errorText | translate }}</span>
</div>
